// This switch is created to:
// (1) set correct old header depending on the retailer
// (2) switch between new and old header

// There are 3 versions of header now:
// 1) New Osp-Styled Header: /base/apps/ospHeader
// 2) Old Ocado header: /base/apps/header
// 3) Old Morrisons header /theme-morrisons/apps/header

import React from 'react';
import { connect } from 'react-redux';

import OldHeader from '[theme-lib]/apps/header/containers/Header';
import NewHeader from 'apps/ospHeader/containers/Header';

function HeaderSwitch(props) {
  const shouldDisplayNewHeader =
    !!props.betaFeatures && props.betaFeatures.includes('ALTERNATIVE_HEADER_VER_O');

  if (!shouldDisplayNewHeader) {
    return <OldHeader {...props} />;
  }

  return <NewHeader {...props} />;
}

export default connect(mapStateToProps)(HeaderSwitch);

function mapStateToProps(state) {
  return {
    betaFeatures: state.user.betaFeatures,
  };
}
